<template>
  <tr class="_middle">
    <td>
      <div class="account-tab-item__date">
        {{ item.created_at | formatDate }}
      </div>
    </td>

    <td>
      <div class="account-tab-item__status">
        <div v-if="item.type === INCOME_MY"
             class="status _yellow">
          {{ $tAccount('My income') }}
        </div>
        <div v-if="item.type  === INCOME_FROM_PARTNER"
             class="status _grey-dark">
          {{ $tAccount('From partner') }}
        </div>
      </div>
    </td>

    <td>
      <div class="account-tab-item__operation">
        <template>
          <div class="account-tab-item__operation-el">
            <BaseSvg :name="item.source.icon"
                     class="account-tab-item__operation-ico"/>
            <span>{{ item.source.name }}</span>
          </div>
        </template>

        <div v-if="item.source_customer_id"
             class="account-tab-item__operation-el">
          <div class="account-tab-item__user-small">
            <span class="account-tab-item__user-small-avatar"
                  :style="{backgroundImage: `url(${item.source_customer_id.avatar})`}"></span>
            <span class="account-tab-item__user-small-name">
              {{ item.source_customer_id.fullname }}
            </span>
          </div>
        </div>
      </div>
    </td>

    <td>
      <div class="account-tab-item__status">
        <div v-if="item.user_type === EMPLOYEE"
             class="status _green">
          {{ $tAccount('Employee') }}
        </div>
        <div v-if="item.user_type === PARTNER"
             class="status _aqua">
          {{ $tAccount('Partner') }}
        </div>
      </div>
    </td>

    <td>
      <div v-if="item.partner"
           class="account-tab-item__user-small">
        <span class="account-tab-item__user-small-avatar"
              :style="{backgroundImage: `url(${item.partner.avatar})`}"></span>
        <div class="account-tab-item__user-small-name">
          {{ item.partner.fullname }}
        </div>
      </div>
    </td>

    <td class="_text-right">
      <div class="account-tab-item__sum-wrap">
        <div class="account-tab-item__sum">
          + {{ item.summ | formatCurrency }} <span>JBN</span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import {EMPLOYEE, PARTNER} from '@/constants/usersTypes'

  const INCOME_MY = 1
  const INCOME_FROM_PARTNER = 2

  export default {
    name: 'AccountTabItemHistoryRowDesktop',
    props: {
      item: Object
    },
    data() {
      return {
        EMPLOYEE,
        PARTNER,

        INCOME_MY,
        INCOME_FROM_PARTNER,
      }
    },
    computed: {
      partnerPlaceholder() {
        return this.item.partner.firstname + this.item.partner.firstname
      }
    }
  }
</script>

<style>

</style>
